import { IDocument } from './cloud/database/DatabaseItemsDefinitions'
import { IUser } from './Users'

export interface IApprovalRequest extends IDocument {

    // --- Core Identifiers & Status ---
    uuid: string
    /**
     * When this approval is created, the UUID of the item that this approval needs to approve.
     * e.g. uuid of the object with version 1
     * e.g. the contract that was sent to approve, the settlement, ....
     */
    originalEntityUUID: string
    /**
     * When this approval is created, this is the UUID of the newly created item with the new version.
     * e.g. uuid of the object with version 2 (even if the approval is rejected or never closed, since the new item is created when the approval is created)
     */
    approvalEntityUUID: string
    /**
     * Type of the entity (e.g., 'contract')
     */
    entityType: ApprovalEntityType
    entityName: string // Name of the entity.
    status: ApprovalStatus
    changes: IApprovalChange[]
    owners: IUser['uuid'][]
    approvalGroup: string
    metadata?: ApprovalMetadata
}

export interface IApprovalChange {
    uuid: string
    status: ApprovalStatus
    changedBy: string
    changedAt: string
    description?: string
    userName?: string // only for the front-end
}

export type ApprovalStatus = 'draft' | 'approved' | 'ready-for-review' | 'rejected'

export type ApprovalEntityType = 'contract' | 'schema' | 'flow' | 'settlement'

interface ApprovalMetadata {
    // // Promotion metadata for when an entity gets promoted to HEAD
    // promotedToHeadAt?: string
    // originalEntityUUID?: string
    // promotedFromVersion?: number
    // promotedToVersion?: number

    // // Archive metadata for when an approval gets archived due to demotion
    // demotedFromVersion?: number
    // replacedByApproval?: string
    // replacedByEntity?: string
    // wasHeadUntil?: string
    // archiveReason?: string

    // // General metadata
    // createdAt?: string

    // Future extensibility
    [key: string]: any
}

export type IApprovalGroupFilters = 'contracts' | 'settlements' | 'schemas' | 'flows'

export interface IApprovalFilters {
    entityType?: ApprovalEntityType
    status?: ApprovalStatus[]
    requestedBy?: string
    assignedTo?: string
    fromDate?: string
    toDate?: string
    approvalEntityUUID?: string
}
// TODO: FOR THE LAST APPROVED CREATE A DIFFERENT STATUS CHIP

export const statusOptions = [
    { value: 'approved', label: 'Approved' },
    { value: 'ready-for-review', label: 'Ready for Review' },
    { value: 'draft', label: 'Draft' },
    { value: 'rejected', label: 'Rejected' }
]

export interface IApprovalAuditChanges {
    type: 'create' | 'update' | 'delete'
    path?: string
    prevValue?: any
    newValue?: any
}

export interface IApprovalAuditResponse {
    oldEntity: {
        [key: string]: any
        approval: {
            fullName: IUser['fullName']
            uuid: IApprovalRequest['uuid']
            approvalEntityUUID: IApprovalRequest['approvalEntityUUID']
            entityName: IApprovalRequest['entityName']
            entityType: IApprovalRequest['entityType']
            status: IApprovalRequest['status']
            changes: IApprovalRequest['changes']
        }
    }
    newEntity: {
        [key: string]: any
        approval: {
            fullName: IUser['fullName']
            uuid: IApprovalRequest['uuid']
            approvalEntityUUID: IApprovalRequest['approvalEntityUUID']
            entityName: IApprovalRequest['entityName']
            entityType: IApprovalRequest['entityType']
            status: IApprovalRequest['status']
            changes: IApprovalRequest['changes']
        }
    }
    comparisons: IApprovalAuditChanges[]
}
